import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a879d71"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "background-color": "white",
    "padding": "20px"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "警情管理", -1));
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_image = _resolveComponent("el-image");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "crumbs"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      "icon-class": "house"
    }), _hoisted_2]),
    _: 1
  }), _createVNode(_component_el_row, {
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
      "table-id": "3"
    }, {
      "operates-handle": _withCtx(data => [_createElementVNode("span", {
        onClick: $event => $options.viewEvent(data.data.id),
        style: {
          "color": "#005FF5",
          "cursor": "pointer"
        }
      }, "警情看板", 8, _hoisted_3)]),
      previewImage: _withCtx(data => [_createVNode(_component_el_image, {
        "preview-teleported": "",
        style: {
          "width": "100px",
          "height": "100px"
        },
        src: `${data.rowData}?x-oss-process=image/resize,p_20`,
        "preview-src-list": [data.rowData],
        fit: "cover"
      }, null, 8, ["src", "preview-src-list"])]),
      _: 1
    })]),
    _: 1
  })]), _createVNode(_component_DialogCustomView, {
    "visible-control": $data.eventViewVisible,
    onClose: _cache[0] || (_cache[0] = $event => $data.eventViewVisible = false),
    width: "450px",
    title: "警情看板"
  }, {
    default: _withCtx(() => [$data.eventViewVisible ? (_openBlock(), _createElementBlock("iframe", {
      key: 0,
      src: $data.eventUrl,
      style: {
        "width": "100%",
        "height": "600px"
      }
    }, null, 8, _hoisted_4)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible-control"])], 64);
}